<button mat-button (click)="closeModal()" color="warn" class="close-confirm-modal">
  <mat-icon>close</mat-icon>
</button>

<div class="error-message">
  <p>{{ "model.patient.errorGeneratePassword" | translate }}</p>
  <p>{{ "model.patient.pleaseTryLater" | translate }}</p>
</div>
